import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from './Services/logging.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private loggingService: LoggingService) {
        super();
    }

    handleError(error: Error): void {
        try {
            // Check if loggingService is available
            if (this.loggingService) {
                // Log the exception to Application Insights
                this.loggingService.logException(error);
                
                // Log additional context information
                this.loggingService.logTrace(`ErrorHandlerService: ${error.message || error}`, {
                    stack: error.stack,
                    url: window.location.href,
                    userAgent: navigator.userAgent,
                    timestamp: new Date().toISOString(),
                    errorType: error.constructor.name
                });
            }
        } catch (loggingError) {
            // Silent error handling
        }

        // Call the default error handler to maintain normal error handling behavior
        super.handleError(error);
    }
}